import http from 'plugins/axios';

export default {
  getList(data) {
    if (!data.style) return;
    return http.get({
      url: `/la/admin/${data.style}/getList`,
      data: { type: data.type }
    });
  },
  setBargain(content, type) {
    return http.post({
      url: `/la/admin/${type}/changeConf`,
      data: content,
      dataType: 'form'
    });
  },
  setTotalSwitch(data) {
    return http.post({
      url: `/la/admin/${data.type}/setMaster`,
      data: { button: data.button },
      dataType: 'form'
    });
  },
  setOneSwitch(type, pair, button) {
    return http.post({
      url: `/la/admin/${type}/setPair`,
      data: { pair: pair, button: button },
      dataType: 'form'
    });
  }
};
